import React, { useRef } from 'react';
import { useLocation, useParams, useSearchParams, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Paper } from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import AddEditCategory from './../../AddEditCategory/AddEditCategory';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';

const CategoryAddEditPage = () => {
  const location = useLocation();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const isEdit = location.pathname.indexOf('edit') > -1;
  const backPath = searchParams.get('from') === 'audiobooks' ? '/audiobooks' : '/category';
  const categoryRef = useRef();

  const handleSave = () => {
    categoryRef.current.submit();
  };

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? 'Edit Category' : 'Create New Category'}
          </Typography>
          <Button
            color="error"
            component={Link}
            to={backPath}
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditCategory ref={categoryRef} isEdit={isEdit} selectedId={params.id} />
        </Paper>
      </Box>
    </MainContentContainer>
  );
};

export default CategoryAddEditPage;
